export default "__VITE_ASSET__CGn0VM4w__"